/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { ApiKeyFilter } from '../../../../types/ApiKeyFilter';
import { ApiKeySort } from '../../../../types/ApiKeySort';

export const ApiKeySearchRequest: core.serialization.Schema<
    serializers.ApiKeySearchRequest.Raw,
    Truvity.ApiKeySearchRequest
> = core.serialization.object({
    filter: core.serialization.list(ApiKeyFilter).optional(),
    sort: core.serialization.list(ApiKeySort).optional(),
});

export declare namespace ApiKeySearchRequest {
    export interface Raw {
        filter?: ApiKeyFilter.Raw[] | null;
        sort?: ApiKeySort.Raw[] | null;
    }
}
